import { lazy, Suspense } from 'react';
import { ROUTES } from '@/utils/constants';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from '@/pages/LandingPage';
import { CreatorPage } from '@/pages/public/CreatorPage';
import { ExampleProfilePage } from '@/pages/public/ExampleProfilePage';
// import { StorePage } from '@/pages/public/StorePage';
import { ProtectedRoute } from './ProtectedRoute';

const SignupPage = lazy(() =>
  import('@/pages/auth/SignupPage').then((m) => ({ default: m.SignupPage })),
);
const LoginPage = lazy(() =>
  import('@/pages/auth/LoginPage').then((m) => ({ default: m.LoginPage })),
);
const ForgotPasswordPage = lazy(() =>
  import('@/pages/auth/ForgotPasswordPage').then((m) => ({
    default: m.ForgotPasswordPage,
  })),
);
const GoogleCallbackPage = lazy(() =>
  import('@/pages/auth/GoogleCallbackPage').then((m) => ({
    default: m.GoogleCallbackPage,
  })),
);
const OnboardingPage = lazy(() =>
  import('@/pages/auth/OnboardingPage').then((m) => ({
    default: m.OnboardingPage,
  })),
);
const TermsPage = lazy(() =>
  import('@/pages/legal/TermsPage').then((m) => ({ default: m.TermsPage })),
);
const PrivacyPage = lazy(() =>
  import('@/pages/legal/PrivacyPage').then((m) => ({
    default: m.PrivacyPage,
  })),
);

const DashboardPage = lazy(() =>
  import('@/pages/DashboardPage').then((m) => ({
    default: m.DashboardPage,
  })),
);
const Overview = lazy(() =>
  import('@/components/dashboard/Overview').then((m) => ({
    default: m.Overview,
  })),
);
const AnalyticsManager = lazy(() =>
  import('@/components/dashboard/AnalyticsManager').then((m) => ({
    default: m.AnalyticsManager,
  })),
);
const HighlightsManager = lazy(() =>
  import('@/components/dashboard/HighlightsManager').then((m) => ({
    default: m.HighlightsManager,
  })),
);
const EventsManager = lazy(() =>
  import('@/components/dashboard/EventsManager').then((m) => ({
    default: m.EventsManager,
  })),
);
const SocialsManager = lazy(() =>
  import('@/components/dashboard/SocialsManager').then((m) => ({
    default: m.SocialsManager,
  })),
);
const StreamingManager = lazy(() =>
  import('@/components/dashboard/StreamingManager').then((m) => ({
    default: m.StreamingManager,
  })),
);
const SettingsManager = lazy(() =>
  import('@/components/dashboard/SettingsManager').then((m) => ({
    default: m.SettingsManager,
  })),
);
const ContactManager = lazy(() =>
  import('@/components/dashboard/ContactManager').then((m) => ({
    default: m.ContactManager,
  })),
);

export function AppRoutes() {
  return (
    <Suspense fallback={null}>
      <Routes>
        {/* Product landing */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/auth/callback" element={<GoogleCallbackPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />

        {/* Dashboard — protected */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<DashboardPage />}>
            <Route index element={<Overview />} />
            <Route path="analytics" element={<AnalyticsManager />} />
            <Route path="highlights" element={<HighlightsManager />} />
            <Route path="events" element={<EventsManager />} />
            <Route path="socials" element={<SocialsManager />} />
            <Route path="streaming" element={<StreamingManager />} />
            <Route path="settings" element={<SettingsManager />} />
            <Route path="contact" element={<ContactManager />} />
            <Route path="*" element={<Navigate to="" replace />} />
          </Route>
        </Route>

        {/* Static example profile — must precede the /:slug catch-all */}
        <Route path="/nestra" element={<ExampleProfilePage />} />

        {/* Creator public pages */}
        <Route path="/:slug" element={<CreatorPage />} />
        {/* <Route path="/:slug/store" element={<StorePage />} /> */}

        <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
      </Routes>
    </Suspense>
  );
}
